module.exports = "/images/marking-icon-gallery.svg?547a93c744d7264a5d0856ade3617bcc";